module.exports = __webpack_public_path__ + "static/media/wizualizacja-18.103ffa22.png";